export const getDefaultFilters = (reportType) => {
  if (!reportType || reportType !== 'SearchVerticalCategoryInsightsReport') {
    return {};
  }

  return {
    $and: [
      {
        CountryCode: {
          $in: ["Enum.CountryCode'US'"],
        },
      },
      {
        L1Vertical: {
          $in: ["Enum.L1Vertical'TravelTourism'"],
        },
      },
    ],
  };
};
